import classNames from 'classnames'

import './badge.style.css'

type BadgeStyle = 'default' | 'success' | 'warning' | 'error' | 'grey' | 'blue'

type BadgeSize = 'md' | 'lg'

interface Props {
  text: string
  badgeStyle?: BadgeStyle
  badgeSize?: BadgeSize
  onClick?: () => void
}

export const Badge = ({ text, badgeStyle = 'default', badgeSize = 'md', onClick }: Props) => {
  const className = classNames(`badge ${badgeStyle} ${badgeSize}`)

  return (
    <span className={className} onClick={onClick}>
      {text}
    </span>
  )
}
